import styled from "styled-components";

export const StateContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md, 12px);
  min-height: 320px;
  padding: var(--spacing-xl, 24px);
  text-align: center;
`;

export const StateTitle = styled.span`
  align-self: stretch;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: var(--color-gray-950, #19191b);
`;

export const StateDescription = styled.span`
  align-self: stretch;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-subtle, #7d7e84);
`;

/**
 * Dedicated no-change layout (Figma node 3525:5950): the icon and the
 * title/description text block are grouped with a tight 4px rhythm, centered in
 * the modal body — rather than the evenly-spaced shared state layout above.
 */
export const NoChangeContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xxs, 4px);
  min-height: 320px;
  padding: var(--spacing-xl, 24px);
  text-align: center;
`;

export const NoChangeTitle = styled.span`
  align-self: stretch;
  font-size: 1.25rem;
  font-weight: 900;
  line-height: 1.75rem;
  color: var(--color-gray-950, #19191b);
`;

export const NoChangeDescription = styled.span`
  align-self: stretch;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.75rem;
  /* Figma "System/text/dark-grey"; no matching token in the gray ramp. */
  color: #8b91a4;
`;
